module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/RockStars-449a2510e5a57e6481e1cf81074be2d9.png";